import angular from "angular";
import { FeatureManager } from "./feature-manager.service";

export const FeatureFlagsModule = angular
    .module("apex.core.featureFlags", [])
    .service("featureManager", FeatureManager)
    .name
